import Header from './Header'
import Footer from './Footer'

function EnfermedadesProfesionales() {
    const title =  'Enfermedades Profesionales'
    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/enfermedades-profesionales.png" className="img-fluid" alt="enfermedades profesionales" style={{'padding': '8%'}} />
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="fst-italic justified-text">
                          ¿Tu trabajo te enfermó? Si desarrollaste una patología a causa de tu actividad laboral, <strong>tenés derecho a una indemnización</strong> — esté o no tu enfermedad en el listado oficial.
                        </p>
                        <p className="justified-text">Toda enfermedad producida por la labor diaria del trabajador es reclamable, ya sea que figure en el <strong>listado de Enfermedades Profesionales (<a href='https://servicios.infoleg.gob.ar/infolegInternet/anexos/225000-229999/225309/norma.htm' className='black-link'>Dec. 49/2014</a>)</strong> o no. Si podés demostrar el nexo causal entre tu trabajo y tu enfermedad, corresponde indemnización.</p>

                        <h4>Ejemplos comunes</h4>
                        <ul>
                          <li><i className="bi bi-check-circle" /> Hernias de disco y lumbalgias por esfuerzo físico.</li>
                          <li><i className="bi bi-check-circle" /> Tendinitis, síndrome del túnel carpiano y lesiones por movimientos repetitivos.</li>
                          <li><i className="bi bi-check-circle" /> Hipoacusia por exposición a ruido.</li>
                          <li><i className="bi bi-check-circle" /> Problemas respiratorios por exposición a sustancias.</li>
                          <li><i className="bi bi-check-circle" /> Várices y problemas circulatorios por estar parado muchas horas.</li>
                        </ul>

                        <h4>¿Qué hacemos por vos?</h4>
                        <p className="justified-text">Trabajamos con el <strong>baremo de incapacidades actualizado (Decreto 549/2025)</strong> y con médicos legistas propios para lograr el mayor porcentaje de incapacidad de acuerdo a tu patología.</p>
                        <ul>
                          <li><i className="bi bi-check-circle" /> <strong>Rechazo de enfermedad profesional</strong> — si tu ART no reconoce tu patología como laboral, reclamamos ante la SRT.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo administrativo</strong> ante Comisiones Médicas por tu porcentaje de incapacidad.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Reclamo judicial</strong> contra tu ART para obtener la indemnización que corresponde.</li>
                          <li><i className="bi bi-check-circle" /> <strong>Daño psíquico</strong> — incluimos el componente psicológico que las ART sistemáticamente minimizan.</li>
                        </ul>

                        <p className="justified-text"><strong>No esperes a que se agrave.</strong> Cuanto antes consultes, más opciones tenemos para defender tu caso.</p>
                        <p className="justified-text">Por consultas o inquietudes podés escribirnos al <a className='black-link' href="https://wa.me/+5491124089830?text=Hola%2C%20tengo%20una%20enfermedad%20profesional%20y%20necesito%20asesoramiento">11-2408-9830.</a></p>
                        <br/>
                        <a href="https://wa.me/+5491124089830?text=Hola%2C%20tengo%20una%20enfermedad%20profesional%20y%20necesito%20asesoramiento" className="cta-button">Hablemos de tu caso</a>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>
        </>
    );
}

export default EnfermedadesProfesionales;
